import { get, del, post, put } from './requests.js'
import { v4 as uuidv4 } from 'uuid'

export const BATCH_PREBUILT_ATTRIBUTES_ENDPOINT = 'batch-prebuilt-attribute-processes'

export const newBatchProcess = (data) =>
  post(
    [BATCH_PREBUILT_ATTRIBUTES_ENDPOINT],
    { transformPayload: true },
    { name: uuidv4(), ...data }
  )

// export const updateBatchProcess = (id, data) =>
//   put([BATCH_PREBUILT_ATTRIBUTES_ENDPOINT, id], { transformPayload: true }, { ...data })

export const getBatchProcess = (id) =>
  get([BATCH_PREBUILT_ATTRIBUTES_ENDPOINT, id], { transformPayload: true })

export const approveAllByBatchId = (id) =>
  post([BATCH_PREBUILT_ATTRIBUTES_ENDPOINT, 'approve', id], {
    transformPayload: true,
    removeTrailingSlash: true,
  })

export const stopBatchProcess = (id) =>
  post([BATCH_PREBUILT_ATTRIBUTES_ENDPOINT, 'stop-approving', id], {
    transformPayload: true,
    removeTrailingSlash: true,
  })

export const deleteBatchProcess = (id) =>
  del([BATCH_PREBUILT_ATTRIBUTES_ENDPOINT, id], {
    transformPayload: true,
    removeTrailingSlash: true,
  })
